import { render, staticRenderFns } from "./DlgPlantDetail.vue?vue&type=template&id=10f0d526&scoped=true&"
import script from "./DlgPlantDetail.vue?vue&type=script&lang=js&"
export * from "./DlgPlantDetail.vue?vue&type=script&lang=js&"
import style0 from "./DlgPlantDetail.vue?vue&type=style&index=0&id=10f0d526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0d526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VDivider,VSpacer,VToolbar,VToolbarTitle})
